<template>
  <div id="library" class="h-margin-top-50">
    <div v-if="loaders.library" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <Navigation></Navigation>
    <div class="tab-content">
      <MemberDocuments></MemberDocuments>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import Navigation from '../library/Navigation.vue';
  import MemberDocuments from '../library/MemberDocuments.vue';

  export default {
    name: 'LibraryLayout',
    components: {
      MoonLoader,
      Navigation,
      MemberDocuments,
    },
    computed: {
      ...mapGetters('library', ['loaders', 'initializers']),
    },
    beforeMount() {
      if (!this.initializers.documents) {
        this.$store.dispatch('library/getDocuments');
      }
      if (!this.initializers.vendors) {
        this.$store.dispatch('library/getVendors');
      }
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
